import { RouterSelectors } from '@next/core-lib/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SettingModuleState } from '../../models/setting.model';
import { adapter } from '../reducers/setting.reducer';

const { selectAll } = adapter.getSelectors();

export const getSettingModuleState = createFeatureSelector<SettingModuleState>('settingModule');

export const getBarnState = createSelector(getSettingModuleState, (state) => state.barns);

export const getSelectedBarnId = createSelector(RouterSelectors.getMergedRoute, (state) =>
  !isNaN(parseInt(state.params['barnId'], 10)) ? parseInt(state.params['barnId'], 10) : undefined,
);

export const getBarns = createSelector(getBarnState, selectAll);

export const getBarnsAreaSum = createSelector(getBarns, (barns) =>
  barns ? barns.reduce((acc, curr) => acc + curr.surfaceArea, 0) : 0,
);

export const getSelectedBarn = createSelector(getSettingModuleState, (state) => state.selectedBarn);

export const isDuplicateBarnName = createSelector(
  getBarns,
  getSelectedBarnId,
  (barns, selectedBarnId) => (name: string) =>
    !!barns && barns.findIndex((b) => b.name === name && b.id !== selectedBarnId) !== -1,
);
